import React, { useContext, useEffect, useRef } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faCheck } from '@fortawesome/free-solid-svg-icons'
import Context from "../utils/Context"

export default function ShowMessage() {

  const context = useContext(Context)

  const timer = useRef()

  useEffect(() => {

    if (JSON.stringify(context.message) !== '{}')
      timer.current = setTimeout(() => context.actions.setMessage({}), 3333)
    else
      clearTimeout(timer.current)

  }, [context.message])

  const getIcon = (type) => {
    if (type === "success") {
      return faCheck
    } else if (type === "error") {
      return faExclamationTriangle
    }
    return null
  }



  return (
    <div className="field mb-5">

      <small className={!context.message?.type
        ? "notification is-flex is-hidden"
        : context.message?.type === "error"
          ? "notification is-danger is-flex"
          : "notification is-success is-flex"}>
        {getIcon(context.message?.type) && (
          <span className="icon mr-2">
            <FontAwesomeIcon icon={getIcon(context.message?.type)} />
          </span>
        )}
        {context.message?.message}
      </small>
    </div>
  )

}